<script>
import ValidateMfaPage from './_lang/validate-mfa.vue';
export default ValidateMfaPage;
</script>
<route-meta>
{
  "isPublic": true
}
</route-meta>
